import { DisplayDTO } from '@headless-workspace/domain/common/server';
import { z } from 'zod';

export const HomeSlotBaseDTO = z.object({
    id: z.string(),
    display: DisplayDTO,
});
